import {Link, Outlet} from "react-router";
import {ShieldX} from "lucide-react";
import {useAuthenticatedUser} from "@/auth/AuthHooks.ts";
import {Button} from "@/components/ui/button.tsx";

export default function AdminGuard() {
    const user = useAuthenticatedUser();

    if (!user.admin) {
        return <main className="grid min-h-full place-content-center gap-4 p-6 text-center">
            <title>Kein Zugriff | DireDawn</title>
            <ShieldX className="mx-auto size-12 text-destructive"/>
            <h1 className="text-xl font-semibold">Kein Zugriff</h1>
            <p className="text-muted-foreground">Dieser Bereich ist Administratoren vorbehalten.</p>
            <Button asChild><Link to="/">Zur Kampagnenauswahl</Link></Button>
        </main>;
    }

    return <Outlet/>;
}
